var exports = {
  "iE": "x936d19a0--d29de3--wrapper",
  "vK": "x936d19a0--d29de3--banner",
  "p_": "x936d19a0--d29de3--list",
  "X$": "x936d19a0--d29de3--pagination",
};

module.exports = exports;
